export const getOneLink = (magasin) => {
  return magasin.attributes.urls_carrefour.url_carrefour_app_ios;
};

export const getDriveLink = (magasin) => {
  return magasin.attributes.urls_carrefour.url_carrefour_drive;
};

export const getLadLink = (magasin) => {
  return magasin.attributes.urls_carrefour.url_carrefour_lad;
};

export const getMagasinLink = (magasin) => {
  return magasin.attributes.urls_carrefour.url_carrefour_magasin;
};

export const getProLink = () => {
  return "https://www.pro.carrefour.fr/cora-pro/";
};
